import {createSlice} from '@reduxjs/toolkit'
import {IHomePageQuickLink} from 'models/CMS'

interface IProps {
 status: string
 data: IHomePageQuickLink[] | null
}

const initialState: IProps = {
 status: 'idle',
 data: null,
}

const homePageQuickLinkSlice = createSlice({
 name: 'homePageQuickLink',
 initialState,
 reducers: {
  setHomePageQuickLinkData: (homePageQuickLink, data) => {
   homePageQuickLink.status = 'Success'
   homePageQuickLink.data = data.payload
  },
 },
})

export const {setHomePageQuickLinkData} =
 homePageQuickLinkSlice.actions
export default homePageQuickLinkSlice.reducer
